__turbopack_context__.v({
  "className": "inter_b0975a75-module__vrF_va__className",
});
